<template>
  <div class="order-wrapper">
    <h3>我的订单</h3>
    <template v-if="(un_paid && un_paid.length) || (un_shiped && un_shiped.length) || (finish && finish.length) || (refund && refund.length)">
      <div class="order-container">
        <div class="order-classification" v-if="un_paid">
          <div class="header">待支付（{{un_paid.length}}）</div>
          <div class="order-items">
            <template v-for="(item) in un_paid">
              <OrderItem :source="item" @loadSource="loadSource" :expended="item.order_sn == $route.query.sn" :key="item.order_sn" />
            </template>
          </div>
        </div>
        <div class="order-classification" v-if="un_shiped">
          <div class="header">待收货（{{un_shiped.length}}）</div>
          <div class="order-items">
            <template v-for="(item) in un_shiped">
              <OrderItem :source="item" @loadSource="loadSource" :expended="item.order_sn == $route.query.sn" :key="item.order_sn" />
            </template>
          </div>
        </div>
        <div class="order-classification" v-if="finish">
          <div class="header">已完成（{{finish.length}}）</div>
          <div class="order-items">
            <template v-for="(item) in finish">
              <OrderItem :source="item" @loadSource="loadSource" :expended="item.order_sn == $route.query.sn" :key="item.order_sn" />
            </template>
          </div>
        </div>
        <div class="order-classification" v-if="refund">
          <div class="header">售后处理（{{refund.length}}）</div>
          <div class="order-items">
            <template v-for="(item) in refund">
              <OrderItem :source="item" @loadSource="loadSource" :expended="item.order_sn == $route.query.sn" :key="item.order_sn" />
            </template>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="orders-empty">
        <div class="empty-status">
          <div class="empty-hits">
            <div class="empty-icon">
              <i class="iconfont icon-order_empty">&#xe689;</i>
            </div>
            <div class="empty-text">暂无订单</div>
          </div>
          <button class="go-shipping" @click="toHome">继续购物</button>
        </div>
        <div class="recommond-wrap">
          <Recommend region="empty_order_rec" :isTitle="true" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import OrderItem from '@/components/OrderItem.vue';
import Recommend from '@/components/Recommend.vue';
import types from '@/store/types';
import api from '@/utils/api';
import utils from '@/utils';

export default {
  name: "Orders",
  components: { OrderItem, Recommend },
  data() {
    return {
      un_paid: null,
      un_shiped: null,
      finish: null,
      refund: null
    };
  },
  created() {
    if (utils.isWXBrowser() && !this.$route.query.openid) {
      this.toAuthorization();
      return console.info('[info]:: 微信授权登录'), false;
    }
    this.loadSource();
  },
  methods: {
    loadSource() {
      let pos_id = this.$store.state?.userInfo?.pos_id;
      api[types.ORDER_LIST]({ pos_id }).then(res => {
        if (res.code == 1) {
          let { un_paid, un_shiped, finish, refund } = res.data;
          this.un_paid = un_paid;
          this.un_shiped = un_shiped;
          this.finish = finish;
          this.refund = refund;
        } else if (res.code != 2) {
          this.$toast({ message: res.message, iconCls: "failure" });
        }
      }).catch(err => {
        console.warn(err);
      });
    },
    toHome() {
      this.$router.push({ path: "/" });
    },
    // 微信授权登录
    toAuthorization() {
      api[types.WX_WEB_AUTHORIZE]({
        href: location.href
      }).then(res => {
        if (res.code == 1) {
          location.href = res.data;
        } else {
          this.$message({ message: res.message, iconCls: "failure" });
        }
      }).catch(err => {
        console.warn(err);
      });
    }
  }
}
</script>

<style lang="scss" scoped>
  .order-wrapper {
    h3 { color:#333333; font-weight:bold; font-size: 1.125rem; padding: 1.6875rem 0 1.25rem 0; display: none; }
    .order-container {
      padding: 0 1rem;
      .order-classification {
        margin-bottom: 1.875rem;
        .header {
          font-size: 0.875rem; color: #000000; font-weight: 700; line-height: 1.5625rem;
        }
        .order-items {
          margin-top: 15px;
          & /deep/ .order_item-wrap {
            margin-top: 1.25rem;
            &:first-child { margin-top: 0; }
          }
        }
      }
    }
    .orders-empty {
      height: 100vh; overflow: hidden;
      .empty-status {
        height: calc(100vh - 375px); display: flex; flex-direction: column; justify-content: center; align-items: center;
        .empty-hits {
          display: flex; flex-direction: column; justify-content: center; align-items: center;
          .empty-icon {
            width: 80px; height: 80px; border-radius: 50%; background: #F6F6F6; display: flex; justify-content: center; align-items: center;
            .icon-order_empty { font-size: 40px; color: #C6C6C6; }
          }
          .empty-text { font-size: 18px; color: 000; font-weight: 700; margin-top: 1.25rem; }
        }
        .go-shipping {
          width: 110px; height: 44px; padding: 15px 0; margin-top: 1.25rem;
          font-size: 0.875rem; line-height: 1; color: #FFF; background: #000; border: none; border-radius: 22px;
        }
      }
    }
  }

  @media screen and (min-width: 48em) {
    .order-wrapper {
      h3 { display: block; }
    }
  }

  @media only screen and (min-width: 64rem) {
    .order-wrapper {
      .order-header { display: block; }
      .orders-empty {
        height: auto; // height: 13.125rem; 
        .empty-status {
          height: auto; padding: 4.375rem 3.125rem 4.375rem 5rem; border: 1px solid #DFDFDF; flex-direction: row; justify-content: space-between;
          .empty-hits {
            flex-direction: row; justify-content: flex-start;
            .empty-text { margin-top: 0; margin-left: 1rem; }
          }
          .go-shipping { margin-top: 0; }
        }
      }
    }
  }
</style>